export const paragraphs = description => description.split("\n\n").map((paragraph, index) => <p key={index}>{paragraph}</p>);